import {  Col, Row,  } from "antd";
import TopImportantFilters from "./TopImportantFilters";
import ViewingModes from "./ViewingModes";
import FilterTags from "./FilterTags";
import { useSelector } from "react-redux";
import { RootState } from "store/Reducers";
import SaveFilterDataButton from "./SaveFilterDataButton";
import Sorting from "./Sorting";


const TopOptions = () => {
  const { filter } = useSelector((state: RootState) => state.realState);
  return (
    <>
      <Row gutter={[20, 20]}>
        <Col span={24}>
          <Row gutter={[20, 10]}>
            <Col xs={24} lg={24} >
              <TopImportantFilters isMobile={false} />
            </Col>
            <Col xs={24} className="!flex  gap-2 !flex-wrap" >
              <FilterTags isMobile={false}  />
            </Col>
            <Col xs={24} >
              <Row>
             
                <Col xs={24} lg={12} className="!flex items-center">
                  {Object.entries(filter).length > 13 && (
                    <>
                      <SaveFilterDataButton />
                    </>
                  )}
                </Col>
                <Col xs={24} lg={12} className="!flex justify-end gap-3  ">
                  <Col xs={24} lg={9}>
                    <div className="shadow-sm border p-1" style={{borderRadius:'6px'}}>
                    <Sorting />
                    </div>
                   
                  </Col>
                  <ViewingModes />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default TopOptions;
